export const it = {
  direction: 'ltr',
  messages: {
	ui: {
	  'blockTunes': {
		'toggler': {
		  'Click to tune': 'Clicca per modificare',
		  'or drag to move': 'o trascina per riordinare'
		}
	  },
	  'inlineToolbar': {
		'converter': {
		  'Convert to': 'Converti'
		},
	  },
	  'toolbar': {
		'toolbox': {
		  'Add': 'Aggiungi'
		}
	  },
	  'popover': {
		'Filter': 'Filtra',
		'Nothing found': 'Nessun risultato trovato',
		'Convert to': 'Converti'
	  }
	},
	toolNames: {
	  'Text': 'Testo',
	  'Link': 'Link',
	  'Custombold': 'Grassetto',
	  'Customitalic': 'Corsivo',
	  'Underline': 'Sottolineato',
	  'Customfield': 'Variabile',
	  'Heading': 'Intestazione',
	  'List': 'Lista',
	  'Image': 'Immagine',
	  'Table': 'Tabella',
	  'Document Section': 'Sezione Documento',
	},
	tools: {
	  'link': {
		'Add a link': 'Aggiungi un link'
	  },
	  'header': {
		'Heading 1': 'Intestazione H1',
		'Heading 2': 'Intestazione H2',
		'Heading 3': 'Intestazione H3',
		'Heading 4': 'Intestazione H4',
		'Heading 5': 'Intestazione H5',
		'Heading 6': 'Intestazione H6'
	  },
	  'list': {
		'Unordered': 'Lista non ordinata',
		'Ordered': 'Lista ordinata'
	  },
	  'image': {
		'Click to upload': 'Clicca per caricare un\'immagine',
		'Align Left': 'Allinea a Sinistra',
		'Align Center': 'Allinea al Centro',
		'Align Right': 'Allinea a Destra',
		'Stretch Image': 'Allunga Immagine',
	  },
	  'table': {
		'With headings': 'Con Intestazione',
		'Without headings': 'Senza Intestazione',
		'Heading': 'Intestazione',
		'Add row above': 'Aggiungi riga sopra',
		'Add row below': 'Aggiungi riga sotto',
		'Delete row': 'Elimina riga',
		'Add column to left': 'Aggiungi colonna a sinistra',
		'Add column to right': 'Aggiungi colonna a destra',
		'Delete column': 'Elimina colonna',
		'Merge to Up': 'Unisci Sopra',
		'Merge to Right': 'Unisci a Destra',
		'Merge to Down': 'Unisci Sotto',
		'Merge to Left': 'Unisci a Sinistra',
	  },
	  'stub': {
		'The block can not be displayed correctly.': 'Il blocco non può essere visualizzato correttamente.'
	  }
	}, 
	blockTunes: {
	  'alignment': {
		'Align Block': 'Allinea Blocco',
		'Align Left': 'Allinea a Sinistra',
		'Align Center': 'Allinea al Centro',
		'Align Right': 'Allinea a Destra',
		'Align Justify': 'Giustifica',
	  },
	  'variables': {
		'Load Variable': 'Carica Variabile'
	  },
	  'delete': {
		'Delete': 'Elimina',
		'Click to delete': 'Clicca per eliminare'
	  },
	  'moveUp': {
		'Move up': 'Muovi su'
	  },
	  'moveDown': {
		'Move down': 'Muovi giù'
	  }
	}
  }
}